import React from 'react';
import { Panel } from 'rsuite';
import Dashboard from './Dashboard';
import Copyright from '@/components/Copyright';
import GrowwizoSimpleHomeDashboard from './Dashboard2.0';

const Page = () => {
  return (
    // header={<h3 className="titled" style={{'background':'#fff','width':'100%','paddingLeft':'15px', 'borderRadius':'8px'}}>Dashboard</h3>}
    <Panel >
      {/* <Dashboard /> */}
      <GrowwizoSimpleHomeDashboard />

    </Panel>

  );
};

export default Page;
